import { createContext, useContext, type ReactNode } from 'react';
import { useAppUpdate, RUNNING_VERSION, type UseAppUpdateResult } from '@/hooks/core/useAppUpdate';

const AppUpdateContext = createContext<UseAppUpdateResult | undefined>(undefined);

/**
 * Monte la detection de version UNE seule fois pour toute l'application et la
 * partage : le bandeau de mise a jour et l'ecran Reglages lisent le meme etat.
 */
export const AppUpdateProvider = ({ children }: { children: ReactNode }) => {
  const value = useAppUpdate();
  return <AppUpdateContext.Provider value={value}>{children}</AppUpdateContext.Provider>;
};

/**
 * Hors provider (ex: un ecran monte isolement dans un test), renvoie un etat
 * inerte plutot que de lever : l'affichage de la version ne doit jamais casser une page.
 */
export const useAppUpdateContext = (): UseAppUpdateResult => {
  const context = useContext(AppUpdateContext);
  if (context) return context;
  return {
    runningVersion: RUNNING_VERSION,
    deployedVersion: null,
    updateAvailable: false,
    dismissed: false,
    checking: false,
    checkForUpdate: async () => null,
    applyUpdate: async () => undefined,
    dismissUpdate: () => undefined,
  };
};
